/**
 * <p>****************************************************************************</p >
 * <p><b>Copyright  2013-2019/6/10 soho team All Rights Reserved<b></p >
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019/6/10</li>
 * <li>@author     : 唐胜</li>
 * </ul>
 * <p>****************************************************************************</p >
 */
import request from '../kernel/request'

export default {
    list(params) {
        return request.get('classType/list', params)
    },
    subject(params) {
        return request.get('classType/subject', params)
    },
    num(id) {
        return request.get('classType/num/' + id)
    },
    save(data) {
        return request.post(`classType`, data)
    },
    update(data) {
        return request.put(`classType`, data)
    },
    updateStatus(data) {
        return request.put(`/classType/status`, data)
    },
    delete(id) {
        return request.delete('classType/' + id)
    },
    load(id) {
        return request.get('classType/' + id)
    },
    loadBy(id) {
        return request.get('classType/loadBy/' + id)
    },
    loadClass(id) {
        return request.get('classType/class/' + id)
    },
    getSubject(params) {
        return request.get('classType/getSubject', params)
    },
    model(id) {
        return request.get('classType/model/' + id)
    },
    studentClass: {
        list(params) {
            return request.get('student/class', params)
        },
        save(data) {
            return request.post(`student/class`, data)
        },
        update(data) {
            return request.put(`student/class`, data)
        },
        delete(id) {
            return request.delete('student/class/' + id)
        },
        load(id) {
            return request.get('student/class/' + id)
        },
        saveStudentClass(params) {
            return request.post('student/class/saveStudentClass', params)
        }
    },
    classGroup: {
        list(params) {
            return request.get('classGroup', params)
        },
        page(params) {
            return request.get('classGroup/page', params)
        },
        wait(params) {
            return request.get('classGroup/wait', params)
        },
        group(params) {
            return request.get('classGroup/group', params)
        },
        groupPage(params) {
            return request.get('classGroup/group/page', params)
        },
        insert(params) {
            return request.post('classGroup/insert', params)
        },
        loadBy(id) {
            return request.get('classGroup/group/' + id)
        },
        remove(id) {
            return request.get('classGroup/remove/' + id)
        },
        save(data) {
            return request.post('classGroup/save', data)
        },
        update(data) {
            return request.put(`classGroup`, data)
        },
        delete(id) {
            return request.delete('classGroup/' + id)
        },
        load(id) {
            return request.get('classGroup/' + id)
        }
    },
    classPaper: {
        list(params) {
            return request.get('class/paper', params)
        },
        save(data) {
            return request.post(`class/paper`, data)
        },
        update(data) {
            return request.put(`class/paper`, data)
        },
        delete(id) {
            return request.delete('class/paper/' + id)
        },
        load(id) {
            return request.get('class/paper' + id)
        },
        groupByQuestion(params) {
            return request.get(`class/paper/groupByQuestion`, params)
        },
        groupDetail(params) {
            return request.get(`class/paper/detail`, params)
        },
        getQuestion(id) {
            return request.get(`class/paper/getQuestion/` + id)
        },
        download(params) {
            return request.download(`class/paper/download/`, params)
        }
    },
    classRecord: {
        list(params) {
            return request.get('class/record', params)
        },
        save(data) {
            return request.post(`class/record`, data)
        },
        update(data) {
            return request.put(`class/record/`, data)
        },
        delete(id) {
            return request.delete('class/record/' + id)
        },
        load(id) {
            return request.get('class/record/' + id)
        },
        loadGroupName(id) {
            return request.get('class/record/getClassGroup/' + id)
        },
        getStudentAndClass(data) {
            return request.get(`class/record/getStudentAndClass`, data)
        },
        getReportPaperRecord(data) {
            return request.get(`class/record/getReportPaperRecord`, data)
        }
    },
    classAnswer: {
        list(params) {
            return request.get('class/answer', params)
        },
        save(data) {
            return request.post(`class/answer`, data)
        },
        update(data) {
            return request.put(`class/answer`, data)
        },
        delete(id) {
            return request.delete('class/answer' + id)
        },
        load(id) {
            return request.get('class/answer' + id)
        },
        reportAnswer(params) {
            return request.get('class/answer/reportAnswer', params)
        }
    },
    changeClass: {
        list(params) {
            return request.get('change/class', params)
        },
        save(data) {
            return request.post('change/class', data)
        },
        quitSchool(params) {
            return request.post('change/class/quitSchool', params)
        },
        quit(params) {
            return request.get('change/class/quit', params)
        },
        quitMember(params) {
            return request.get('change/class/quit/member', params)
        },
        backSchool(id) {
            return request.post('change/class/backSchool/' + id)
        },
        update(data) {
            return request.put(`change/class`, data)
        },
        delete(id) {
            return request.delete('change/class/' + id)
        },
        load(id) {
            return request.get('change/class/' + id)
        },
        classList(id) {
            return request.post('change/class/list/' + id)
        },
        uploadQuit: `${request.baseURL}/change/class/uploadQuit`
    },
    ExamResults: {
        list(params) {
            return request.get('/exam/results', params)
        },
        resultPage(params) {
            return request.get('/exam/results/resultPage', params)
        },
        uploadPage(params) {
            return request.get('/exam/results/uploadPage', params)
        },
        save(data) {
            return request.post(`/exam/results`, data)
        },
        saveGrade(data) {
            return request.post(`/exam/results/saveGrade`, data)
        },
        saveMiddleGrade(data) {
            return request.post(`/exam/results/save/middle`, data)
        },
        saveEdu(data) {
            return request.post(`/exam/results/save/edu`, data)
        },
        update(data) {
            return request.put(`/exam/results`, data)
        },
        delete(id) {
            return request.delete('/exam/results' + id)
        },
        load(id) {
            return request.get('/exam/results' + id)
        },
        classList(id) {
            return request.get('/exam/results/class/' + id)
        },
        import(params) {
            return request.upload('/exam/results/import', params)
        }
    }
}
